"use strict";
/*
 *  Copyright (C) 2019  Attila Aldemir <a_aldemir@hotmail.de>
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU Affero General Public License as published
 *  by the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU Affero General Public License for more details.
 *
 *  You should have received a copy of the GNU Affero General Public License
 *  along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ardor_ts_1 = require("@blobaa/ardor-ts");
var constants_1 = require("../../constants");
var types_1 = require("../../types");
var Helper_1 = __importDefault(require("./Helper"));
var DataField;
(function (DataField) {
    DataField[DataField["VERSION"] = 0] = "VERSION";
    DataField[DataField["ENTITY"] = 1] = "ENTITY";
    DataField[DataField["STATE"] = 2] = "STATE";
    DataField[DataField["REDIRECT_ACCOUNT"] = 3] = "REDIRECT_ACCOUNT";
    DataField[DataField["PAYLOAD"] = 4] = "PAYLOAD";
})(DataField || (DataField = {}));
var DataFields = /** @class */ (function () {
    function DataFields(dataFields) {
        var _this = this;
        this._attestationContext = "";
        this.version = constants_1.PROTOCOL_VERSION;
        this.entityType = types_1.EntityType.LEAF;
        this.state = types_1.State.INACTIVE;
        this.redirectAccount = constants_1.DUMMY_ACCOUNT_RS;
        this.payload = "";
        this.setAttestationContext = function (context) {
            return context.startsWith(constants_1.PROTOCOL_IDENTIFIER) ? context : constants_1.PROTOCOL_IDENTIFIER + context;
        };
        this.consumeDataFieldString = function (dataFieldString) {
            var dataFields = dataFieldString.split(constants_1.DATA_FIELD_SEPARATOR);
            var error = _this.checkDataFields(dataFields);
            if (error.code !== types_1.ErrorCode.NO_ERROR) {
                return error;
            }
            _this.version = dataFields[DataField.VERSION];
            _this.entityType = dataFields[DataField.ENTITY];
            _this.state = dataFields[DataField.STATE];
            _this.redirectAccount = dataFields[DataField.REDIRECT_ACCOUNT];
            _this.payload = dataFields.slice(constants_1.NUMBER_OF_DATA_FIELDS - 1).join(constants_1.DATA_FIELD_SEPARATOR);
            return constants_1.noError;
        };
        this.checkDataFields = function (dataFields) {
            var payload = dataFields.slice(constants_1.NUMBER_OF_DATA_FIELDS - 1).join(constants_1.DATA_FIELD_SEPARATOR);
            var _dataFields = dataFields.slice(0, constants_1.NUMBER_OF_DATA_FIELDS);
            if (_dataFields.length !== constants_1.NUMBER_OF_DATA_FIELDS) {
                var _error = Helper_1.default.createError(types_1.ErrorCode.WRONG_NUMBER_OF_DATA_FIELDS, ["" + (constants_1.NUMBER_OF_DATA_FIELDS + 1), constants_1.DATA_FIELD_SEPARATOR]);
                return _error;
            }
            var error = _this.checkVersion(_dataFields[DataField.VERSION]);
            if (error.code !== types_1.ErrorCode.NO_ERROR) {
                return error;
            }
            error = _this.checkEntityType(_dataFields[DataField.ENTITY]);
            if (error.code !== types_1.ErrorCode.NO_ERROR) {
                return error;
            }
            error = _this.checkState(_dataFields[DataField.STATE]);
            if (error.code !== types_1.ErrorCode.NO_ERROR) {
                return error;
            }
            error = _this.checkRedirectAccount(_dataFields[DataField.REDIRECT_ACCOUNT]);
            if (error.code !== types_1.ErrorCode.NO_ERROR) {
                return error;
            }
            error = _this.checkPayload(payload);
            if (error.code !== types_1.ErrorCode.NO_ERROR) {
                return error;
            }
            return constants_1.noError;
        };
        this.checkVersion = function (version) {
            if (version.length !== 3) {
                var error = Helper_1.default.createError(types_1.ErrorCode.WRONG_VERSION_LENGTH);
                return error;
            }
            if (version !== constants_1.PROTOCOL_VERSION) {
                var error = Helper_1.default.createError(types_1.ErrorCode.WRONG_VERSION, [constants_1.PROTOCOL_VERSION]);
                return error;
            }
            return constants_1.noError;
        };
        this.checkEntityType = function (entityType) {
            if (entityType.length !== 1) {
                var error = Helper_1.default.createError(types_1.ErrorCode.WRONG_ENTITY_TYPE_LENGTH);
                return error;
            }
            if (entityType !== types_1.EntityType.LEAF && entityType !== types_1.EntityType.INTERMEDIATE && entityType !== types_1.EntityType.ROOT) {
                var error = Helper_1.default.createError(types_1.ErrorCode.UNKNOWN_ENTITY_TYPE);
                return error;
            }
            return constants_1.noError;
        };
        this.checkState = function (state) {
            if (state.length !== 1) {
                var error = Helper_1.default.createError(types_1.ErrorCode.WRONG_STATE_TYPE_LENGTH);
                return error;
            }
            if (state !== types_1.State.ACTIVE && state !== types_1.State.INACTIVE && state !== types_1.State.DEPRECATED) {
                var error = Helper_1.default.createError(types_1.ErrorCode.UNKNOWN_STATE_TYPE);
                return error;
            }
            return constants_1.noError;
        };
        this.checkRedirectAccount = function (redirectAccount) {
            var accountPrefix = constants_1.ACCOUNT_PREFIX;
            if (redirectAccount.length !== constants_1.REDIRECT_ACCOUNT_CHARACTER_LENGTH) {
                var error = Helper_1.default.createError(types_1.ErrorCode.WRONG_REDIRECT_ACCOUNT_LENGTH, ["" + constants_1.REDIRECT_ACCOUNT_CHARACTER_LENGTH]);
                return error;
            }
            if (!ardor_ts_1.account.checkAccountRs(accountPrefix + redirectAccount) && redirectAccount !== constants_1.DUMMY_ACCOUNT_RS) {
                var error = Helper_1.default.createError(types_1.ErrorCode.INVALID_REDIRECT_ACCOUNT);
                return error;
            }
            return constants_1.noError;
        };
        this.checkPayload = function (payload) {
            if (payload.length > constants_1.MAX_PAYLOAD_LENGTH) {
                var error = Helper_1.default.createError(types_1.ErrorCode.PAYLOAD_TOO_LONG, ["" + constants_1.MAX_PAYLOAD_LENGTH]);
                return error;
            }
            return constants_1.noError;
        };
        this.createDataFieldsString = function () {
            var dataFieldString = "";
            dataFieldString += _this.version + constants_1.DATA_FIELD_SEPARATOR;
            dataFieldString += _this.entityType + constants_1.DATA_FIELD_SEPARATOR;
            dataFieldString += _this.state + constants_1.DATA_FIELD_SEPARATOR;
            dataFieldString += _this.redirectAccount + constants_1.DATA_FIELD_SEPARATOR;
            dataFieldString += _this.payload;
            return dataFieldString;
        };
        this.attestationContext = (dataFields && dataFields.attestationContext) || "";
        this.version = (dataFields && dataFields.version) || constants_1.PROTOCOL_VERSION;
        this.entityType = (dataFields && dataFields.entityType) || types_1.EntityType.LEAF;
        this.state = (dataFields && dataFields.state) || types_1.State.INACTIVE;
        this.redirectAccount = (dataFields && dataFields.redirectAccount) || constants_1.DUMMY_ACCOUNT_RS;
        this.payload = (dataFields && dataFields.payload) || "";
    }
    Object.defineProperty(DataFields.prototype, "attestationContext", {
        /*eslint-disable @typescript-eslint/explicit-function-return-type*/
        get: function () {
            return this._attestationContext;
        },
        /*eslint-enable @typescript-eslint/explicit-function-return-type*/
        set: function (value) {
            this._attestationContext = this.setAttestationContext(value);
        },
        enumerable: true,
        configurable: true
    });
    return DataFields;
}());
exports.default = DataFields;
